// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080'
export const API_TIMEOUT = import.meta.env.VITE_API_TIMEOUT || 30000

// Storage Keys
export const TOKEN_KEY = import.meta.env.VITE_TOKEN_KEY || 'erp_access_token'
export const REFRESH_TOKEN_KEY = import.meta.env.VITE_REFRESH_TOKEN_KEY || 'erp_refresh_token'
export const USER_KEY = 'erp_user'
export const LANG_KEY = 'erp_language'
export const THEME_KEY = 'erp_theme'

// Feature Flags
export const ENABLE_AI_CHAT = import.meta.env.VITE_ENABLE_AI_CHAT === 'true'
export const ENABLE_ANALYTICS = import.meta.env.VITE_ENABLE_ANALYTICS === 'true'

// Pagination
export const DEFAULT_PAGE_SIZE = 10
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100]

// Date Formats
export const DATE_FORMAT = 'DD/MM/YYYY'
export const DATETIME_FORMAT = 'DD/MM/YYYY HH:mm'
export const TIME_FORMAT = 'HH:mm'
export const API_DATE_FORMAT = 'YYYY-MM-DD'
export const API_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss'

// Status Constants
export const FACTURE_STATUS = {
  DRAFT: 'BROUILLON',
  VALIDATED: 'VALIDEE',
  PREPARATION: 'EN_PREPARATION',
  SHIPPED: 'EXPEDIEE',
  DELIVERED: 'LIVREE',
  PAID: 'PAYEE',
  CANCELLED: 'ANNULEE',
  OVERDUE: 'IMPAYEE',
}

export const DELIVERY_NOTE_STATUS = {
  PREPARATION: 'EN_PREPARATION',
  SHIPPED: 'EXPEDIE',
  DELIVERED: 'LIVRE',
  CANCELLED: 'ANNULE',
}

export const PAYMENT_STATUS = {
  PENDING: 'EN_ATTENTE',
  PARTIAL: 'PARTIEL',
  PAID: 'PAYE',
  REFUNDED: 'REMBOURSE',
  UNPAID: 'IMPAYE',
}

export const STOCK_STATUS = {
  IN_STOCK: 'EN_STOCK',
  LOW_STOCK: 'STOCK_BAS',
  OUT_OF_STOCK: 'RUPTURE',
  RESERVED: 'RESERVE',
}

export const USER_ROLES = {
  ADMIN: 'ROLE_ADMIN',
  MANAGER: 'ROLE_MANAGER',
  USER: 'ROLE_USER',
  VIEWER: 'ROLE_VIEWER',
}

// Validation Rules
export const VALIDATION_RULES = {
  email: {
    pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    message: 'Email invalide',
  },
  phone: {
    pattern: /^[+]?[\d\s()-]{8,}$/,
    message: 'Numéro de téléphone invalide',
  },
  password: {
    minLength: 8,
    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
    message: 'Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule, un chiffre et un caractère spécial',
  },
  siret: {
    pattern: /^\d{14}$/,
    message: 'SIRET invalide (14 chiffres)',
  },
  tva: {
    pattern: /^[A-Z]{2}\d{11}$/,
    message: 'Numéro TVA invalide',
  },
}

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Erreur de connexion au serveur',
  UNAUTHORIZED: 'Session expirée, veuillez vous reconnecter',
  FORBIDDEN: 'Vous n\'avez pas les droits nécessaires',
  NOT_FOUND: 'Ressource introuvable',
  SERVER_ERROR: 'Erreur serveur, veuillez réessayer',
  VALIDATION_ERROR: 'Erreur de validation des données',
  UNKNOWN_ERROR: 'Une erreur inattendue s\'est produite',
}

// Routes
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  
  // Sales
  CLIENTS: '/clients',
  FACTURES: '/factures',
  DELIVERY_NOTES: '/livraisons',
  /** Facture groupée depuis plusieurs BL (même client) */
  DELIVERY_NOTES_INVOICE: '/livraisons/facturer-bl',
  AVOIRS: '/avoirs',
  QUOTES: '/quotes',
  PAYMENTS: '/payments',
  /** Situation client : factures ouvertes + BL (régularisation) */
  PAYMENTS_REGULARIZATION: '/payments/regularisation',
  PAYMENTS_REGULARIZATION_GLOBAL: '/payments/regularisation/global',
  
  // Inventory
  PRODUITS: '/produits',
  // Purchases
  ACHATS_DASHBOARD: '/achats',
  PURCHASE_REQUESTS: '/achats/demandes',
  PURCHASE_ORDERS: '/achats/commandes',
  PURCHASE_SUPPLIERS: '/achats/fournisseurs',
  PURCHASE_INVOICES: '/achats/factures',
  /** Facture fournisseur groupée depuis plusieurs BL fournisseur (même fournisseur) */
  PURCHASE_INVOICES_FROM_RECEIPTS: '/achats/factures/depuis-bl',
  PURCHASE_RECEIPTS: '/achats/receptions',
  PURCHASE_PAYMENTS: '/achats/paiements',
  /** Situation fournisseur : factures ouvertes + BL fournisseur (régularisation) */
  PURCHASE_PAYMENTS_REGULARIZATION: '/achats/paiements/regularisation',
  PURCHASE_PAYMENTS_REGULARIZATION_GLOBAL: '/achats/paiements/regularisation/global',
  PURCHASE_TEJ_EXPORT: '/achats/retenue-source/tej',
  PURCHASE_RETURNS: '/achats/retours',
  STOCK: '/stock',
  STOCK_DASHBOARD: '/stock/dashboard',
  STOCK_ANALYTICS: '/stock/analytics',
  PRODUCT_LABELS: '/produits/labels',
  WAREHOUSES: '/stock/warehouses',
  STOCK_TRANSFER: '/stock/transfers',
  
  // Analytics
  REPORTS: '/rapports',
  ANALYTICS: '/analytics',
  
  // AI & Settings
  CHAT_IA: '/chat-ia',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  SETTINGS_CASHIERS: '/settings/cashiers',
}

// Chart Colors
export const CHART_COLORS = {
  primary: '#c62828',
  secondary: '#757575',
  success: '#4caf50',
  warning: '#ff9800',
  error: '#f44336',
  info: '#2196f3',
  palette: [
    '#c62828',
    '#1e88e5',
    '#43a047',
    '#fb8c00',
    '#8e24aa',
    '#00acc1',
    '#f4511e',
    '#6d4c41',
  ],
}

// File Upload
export const MAX_FILE_SIZE = 5 * 1024 * 1024 // 5MB
export const ALLOWED_FILE_TYPES = {
  images: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
  documents: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  spreadsheets: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
}

// Debounce Times (ms)
export const DEBOUNCE_TIMES = {
  SEARCH: 300,
  AUTOSAVE: 10000,
  RESIZE: 150,
}

// Languages
export const LANGUAGES = [
  { code: 'fr', name: 'Français', flag: '🇫🇷', dir: 'ltr' },
  { code: 'en', name: 'English', flag: '🇬🇧', dir: 'ltr' },
  { code: 'ar', name: 'العربية', flag: '🇹🇳', dir: 'rtl' },
]

// Currency
export const DEFAULT_CURRENCY = 'TND'
export const CURRENCY_SYMBOLS = {
  EUR: '€',
  USD: '$',
  TND: 'د.ت',
  GBP: '£',
}

// VAT Rates (Tunisia)
export const TVA_RATES = [
  { value: 0, label: '0%' },
  { value: 7, label: '7%' },
  { value: 13, label: '13%' },
  { value: 19, label: '19%' },
]

export const DEFAULT_TVA_RATE = 19

/**
 * Parse un taux TVA (0 % inclus). Évite `parseFloat(x) || 19` qui remplace 0 par 19.
 */
export function parseTvaPercent(value, fallback = DEFAULT_TVA_RATE) {
  if (value === null || value === undefined || value === '') return fallback
  const n = typeof value === 'number' ? value : parseFloat(String(value).replace(',', '.'))
  if (!Number.isFinite(n) || n < 0) return fallback
  return n
}

/**
 * Taux TVA issu du produit (API: tauxTva, etc.). Si absent ou non reconnu parmi TVA_RATES → fallback (19 % par défaut).
 */
export function tvaRateFromProduct(product, fallback = DEFAULT_TVA_RATE) {
  if (!product) return fallback
  const raw = product.tauxTva ?? product.tauxTVA ?? product.tva
  if (raw === null || raw === undefined || raw === '') return fallback
  const n = typeof raw === 'number' ? raw : parseFloat(String(raw).replace(',', '.'))
  if (!Number.isFinite(n)) return fallback
  const rounded = Math.round(n)
  if (TVA_RATES.some((r) => r.value === rounded)) return rounded
  return fallback
}


